exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reprove-modal .modal-title[data-v-311f79ce] {\n  font-size: 28px;\n  color: var(--v-gray-darken2);\n  text-align: center;\n}\n.reprove-modal .modal-text[data-v-311f79ce] {\n  font-size: 18px;\n  color: var(--v-gray-darken2);\n}\n.reprove-modal .reprove-form[data-v-311f79ce] {\n  margin-top: 24px;\n  width: 100%;\n}\n.reprove-modal .counter[data-v-311f79ce] {\n  font-size: 12px;\n  color: var(--v-gray-darken2);\n}\n", ""]);

// exports
